<mat-sidenav-container class="shell">
  <mat-sidenav
    #drawer
    [mode]="isMobile ? 'over' : 'side'"
    [opened]="!isMobile"
    class="sidenav"
  >
    <app-side
      [isMobile]="isMobile"
      (navigate)="closeSidebarIfMobile()"
    ></app-side>
  </mat-sidenav>

  <mat-sidenav-content class="content">
    <app-header (toggleMenu)="toggleSidebar()"></app-header>

    <main class="page">
      <router-outlet></router-outlet>
    </main>

    <app-footer></app-footer>
  </mat-sidenav-content>
</mat-sidenav-container>
